import React from "react";
import { Link } from "react-router-dom";

function Confirmation() {
  return (
    <div className="dark min-h-screen bg-background text-foreground font-jakarta font-light flex items-center justify-center p-4">
      <div className="max-w-2xl w-full bg-card rounded-2xl border border-border p-8 text-center">
        <div className="w-16 h-16 bg-brand/20 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg
            className="w-8 h-8 text-brand"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
        <h1 className="text-3xl font-normal text-foreground mb-4">
          Registration Submitted Successfully
          <span className="text-brand">.</span>
        </h1>
        <p className="text-muted-foreground mb-6 font-light">
          Thank you for registering your business with us. Our payment
          processing experts will review your information and recommend the best
          processors for your specific needs.
        </p>
        <div className="bg-muted border border-brand/30 rounded-lg p-6 mb-6">
          <h3 className="text-lg font-normal text-brand mb-2">
            What happens next?
          </h3>
          <div className="text-left space-y-2 text-muted-foreground font-light">
            <p>• Our team will analyze your business profile within 24 hours</p>
            <p>
              • We'll identify the best payment processors for your industry and
              needs
            </p>
            <p>
              • You'll receive personalized recommendations with rate
              comparisons
            </p>
            <p>
              • We'll handle all applications and negotiations on your behalf
            </p>
          </div>
        </div>
        <p className="text-muted-foreground mb-6 font-light">
          You should receive an email confirmation shortly, followed by our
          recommendations within 1-2 business days.
        </p>
        <Link
          to="/dashboard"
          className="px-6 py-3 bg-brand text-background font-semibold rounded-lg hover:bg-brand-400 transition"
        >
          Go To Dashboard
        </Link>
      </div>
    </div>
  );
}

export default Confirmation;
